<template>
  <BModal
    id="modal-check-before-create-cs-ai"
    ref="modal-check-before-create-cs-ai"
    centered
    size="md"
    :hide-footer="true"
    :hide-header="true"
  >
    <div class="p-2">
      <div class="font-poppins font-semibold text-2xl leading-none text-[#333333] tracking-normal text-center">
        Lengkapi informasi dibawah ini
      </div>
      <div class="text-center mt-1">
        Sebelum melanjutkan, pastikan kamu melengkapi informasi berikut:
      </div>
      <div class="mt-3">
        <div
          v-for="(item, index) in data"
          :key="index"
          :class="item.status? 'border' : '!border !border-[#FF6A3A] bg-[#F8F8F8]'"
          role="button"
          class=" items-center flex justify-between rounded mb-1 p-1"
          @click="handleClick(item.id)"
        >
          <div class="flex items-start gap-2">
            <div
              v-show="item.name === 'Produk'"
              class="border p-[1px] rounded border-[5px] w-fit border-black"
            >
              <b-img
                :width="item.width"
                :src="item.icon"
                alt="icon"
              />
            </div>
            <b-img
              v-show="item.name !== 'Produk'"
              :width="item.width"
              :src="item.icon"
              alt="icon"
            />
            <div>
              <div class=" font-medium text-base mb-[8px] leading-none tracking-normal align-middle text-[#333333]">
                {{ item.name }}
              </div>
              <div class=" font-normal text-xs leading-none tracking-normal align-middle">
                {{ item.description }}
              </div>
            </div>
          </div>
          <b-icon
            :icon="item.status? 'exclamation-circle-fill' : 'check-circle-fill' "
            scale="1.5"
            :variant="item.status? 'warning' : 'success'"
          />
        </div>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalCheckCsAi',
  props: {
    productListEmpty: {
      type: Boolean,
      default: true,
    },
    whatsAppCsAiEmpty: {
      type: Boolean,
      default: true,
    },
    paymentWasSet: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    data() {
      return [
        {
          id: 1,
          name: 'Produk',
          width: '13',
          description: 'Data Produk',
          icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/box-1.svg',
          status: this.productListEmpty,
        },
        {
          id: 2,
          name: 'Fitur Pendukung',
          description: 'Nomor',
          width: '16',
          icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more-2.svg',
          status: this.whatsAppCsAiEmpty,
        },
        {
          id: 3,
          name: 'Pengaturan',
          description: 'Payment',
          width: '16',
          icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/setting.svg',
          status: this.paymentWasSet,
        },
      ]
    },
  },
  methods: {
    handleClick(id) {
      if (id === 1) {
        this.$router.push('/add-produk')
      } else if (id === 2) {
        this.$router.push('/opsional-feature/notifikasi-wa-premium')
      } else if (id === 3) {
        this.$router.push('/setting/payment')
      }
    },
  },
}
</script>
